module.exports = __webpack_public_path__ + "media/images/img_search01-dae5908851ab2bae5d57401bc7b23e09.png";